// @ts-nocheck
import { IS_CLIENT_ENV } from '@helpers/constants';
import createSilentAuth from './createSilentAuth';
import mockCreateSilentAuth from './mockCreateSilentAuth';

let silentAuth: any;
if (IS_CLIENT_ENV) {
  silentAuth =
    window.Cypress && window.useStubSilentAuth
      ? mockCreateSilentAuth
      : createSilentAuth;
}

export default silentAuth;
